var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fl-check" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "fl-check-block" }, [
        _c("div", { staticClass: "input-trio-block" }, [
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lastName,
                    expression: "lastName",
                  },
                ],
                attrs: { id: "surname", type: "text", placeholder: "Фамилия" },
                domProps: { value: _vm.lastName },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.lastName = $event.target.value
                    },
                    function ($event) {
                      _vm.lastName = $event.target.value.replace(
                        /[^а-яa-z-]/gi,
                        ""
                      )
                    },
                  ],
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                attrs: { id: "name", type: "text", placeholder: "Имя" },
                domProps: { value: _vm.name },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    },
                    function ($event) {
                      _vm.name = $event.target.value.replace(/[^а-яa-z-]/gi, "")
                    },
                  ],
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _c("div", { staticClass: "form-group__header" }, [
                _vm._v("Отчество"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fatherName,
                    expression: "fatherName",
                  },
                ],
                attrs: {
                  id: "fatherName",
                  type: "text",
                  placeholder: "Отчество",
                },
                domProps: { value: _vm.fatherName },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.fatherName = $event.target.value
                    },
                    function ($event) {
                      _vm.fatherName = $event.target.value.replace(
                        /[^а-яa-z-]/gi,
                        ""
                      )
                    },
                  ],
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.birthday,
                    expression: "birthday",
                  },
                ],
                attrs: {
                  type: "text",
                  id: "birthday",
                  placeholder: "31.12.2020",
                  maxlength: "10",
                },
                domProps: { value: _vm.birthday },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.birthday = $event.target.value
                    },
                    function ($event) {
                      return _vm.dateFormat($event)
                    },
                  ],
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-duo-block" }, [
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _c("div", { staticClass: "form-group__header" }, [
                _vm._v("ИНН ФЛ"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inn,
                    expression: "inn",
                  },
                ],
                attrs: {
                  id: "inn",
                  placeholder: "ИНН ФЛ",
                  type: "text",
                  maxlength: 12,
                },
                domProps: { value: _vm.inn },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inn = $event.target.value
                    },
                    function ($event) {
                      _vm.inn = $event.target.value.replace(/[^0-9]/g, "")
                    },
                  ],
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _vm._m(4),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seria,
                    expression: "seria",
                  },
                ],
                attrs: {
                  id: "seria",
                  placeholder: "Серия",
                  type: "text",
                  maxlength: 4,
                },
                domProps: { value: _vm.seria },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.seria = $event.target.value
                    },
                    function ($event) {
                      _vm.seria = $event.target.value.replace(/[^0-9]/g, "")
                    },
                  ],
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.number,
                    expression: "number",
                  },
                ],
                attrs: {
                  id: "number",
                  placeholder: "Номер",
                  type: "text",
                  maxlength: 6,
                },
                domProps: { value: _vm.number },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.number = $event.target.value
                    },
                    function ($event) {
                      _vm.number = $event.target.value.replace(/[^0-9]/g, "")
                    },
                  ],
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form-group_inline form-group_inline-x2",
            },
            [
              _c("div", { staticClass: "form-group__header" }, [
                _vm._v("Дата выдачи"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passportDate,
                    expression: "passportDate",
                  },
                ],
                attrs: {
                  type: "text",
                  id: "passportDate",
                  placeholder: "31.12.2020",
                  maxlength: "10",
                },
                domProps: { value: _vm.passportDate },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.passportDate = $event.target.value
                    },
                    function ($event) {
                      return _vm.passportDateFormat($event)
                    },
                  ],
                },
              }),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "buttons__holder" }, [
          _c(
            "button",
            {
              attrs: { id: "clear__button", value: "Очистить" },
              on: { click: _vm.clearInputs },
            },
            [_vm._v("Очистить")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "form-group__button",
              attrs: { value: "Поиск" },
              on: {
                click: function () {
                  return _vm.sendButtonHandler()
                },
              },
            },
            [
              _vm.loading
                ? _c("i", {
                    staticClass: "lnr lnr-sync rotating",
                    staticStyle: {
                      "font-size": "18px",
                      display: "inline-block",
                    },
                    attrs: { title: "Загрузка" },
                  })
                : _c("span", [_vm._v("Поиск")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(5),
    ]),
    _vm._v(" "),
    _vm.history.list
      ? _c(
          "div",
          { staticClass: "container fz16" },
          [
            _vm._m(6),
            _vm._v(" "),
            _c("adminFilters", {
              attrs: { adminType: "check_fl", onFilterCallback: _vm.getList },
              on: { "admin-request": _vm.adminRequest },
            }),
            _vm._v(" "),
            _c("dropDownButton", {
              attrs: {
                title: "Скачать в .xlsx",
                items: ["Первые 5000 записей", "Текущую страницу"],
                onSelect: _vm.downloadXLSX,
              },
            }),
            _vm._v(" "),
            _vm.history.pagination && _vm.history.list.length
              ? _c("pagination", {
                  attrs: {
                    pagination: _vm.history.pagination,
                    onTurnPageCallBack: _vm.getList,
                    showRowsPerPageSelection: false,
                    rows_on_page: _vm.history.list.length,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "content-table", staticStyle: { width: "100%" } },
              [
                _c("tr", { staticClass: "content-table-body-item" }, [
                  _c("th", { attrs: { id: "requestNumber" } }, [
                    _vm._v("Номер проверки"),
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { id: "requestDate" } }, [
                    _vm._v("Дата и время проверки"),
                  ]),
                  _vm._v(" "),
                  _vm.admin
                    ? _c("th", { attrs: { id: "user" } }, [
                        _vm._v("Пользователь"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", { attrs: { id: "requestStatus" } }, [
                    _vm._v("Статус"),
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { id: "requestObject" } }, [
                    _vm._v("Объект проверки"),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.history.list, function (e, i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "content-table-body-item" },
                    [
                      _c("td", { attrs: { id: "numberRequest" } }, [
                        e.number_request
                          ? _c("span", [_vm._v(_vm._s(e.number_request))])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "table-column" }, [
                        e.date_request
                          ? _c("span", [_vm._v(_vm._s(e.date_request))])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.admin
                        ? _c("td", { staticClass: "table-column" }, [
                            _vm.admin
                              ? _c("span", [
                                  _vm._v(_vm._s(e.user_name)),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      e.user_login
                                        ? "(" + e.user_login + ")"
                                        : ""
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", { staticClass: "table-column" }, [
                        _c("div", { attrs: { id: "spinner" } }, [
                          e.status == 0 || e.status == 3
                            ? _c("i", {
                                staticClass: "uk-icon-refresh uk-icon-spin",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          e.status == 1
                            ? _c("i", { staticClass: "uk-icon-check" })
                            : _vm._e(),
                          _vm._v(" "),
                          e.status == 2 || e.status >= 4 || e.status == -1
                            ? _c("i", { staticClass: "uk-icon-times" })
                            : _vm._e(),
                          _vm._v(" "),
                          e.status == 1
                            ? _c("span", [_vm._v(_vm._s("выполнено"))])
                            : e.status == 2
                            ? _c("span", [_vm._v(_vm._s("нет данных"))])
                            : e.status == 0
                            ? _c("span", [_vm._v(_vm._s("в очереди"))])
                            : e.status == 3
                            ? _c("span", [_vm._v(_vm._s("в обработке"))])
                            : e.status == 4
                            ? _c("span", { staticClass: "over-limit" }, [
                                _vm._v(_vm._s("вышло время обработки")),
                              ])
                            : e.status == -1 || e.status > 4
                            ? _c("span", { staticClass: "error-message" }, [
                                _vm._v(_vm._s("ошибка")),
                              ])
                            : e.status == -2
                            ? _c("span", { staticClass: "error-message" }, [
                                _vm._v(_vm._s("ошибка входных данных")),
                              ])
                            : e.status == -3
                            ? _c("span", { staticClass: "error-message" }, [
                                _vm._v(_vm._s("выполнение остановлено")),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "table-column" }, [
                        e.id_file
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "https://api.1clicom.ru/download/" +
                                    e.id_file +
                                    "?sid=" +
                                    _vm.window.apiSession,
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(e.param_request.surname) +
                                      " " +
                                      _vm._s(e.param_request.name) +
                                      " " +
                                      _vm._s(e.param_request.patronymic)
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        e.status == 1
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    "(" +
                                      e.param_request.birthday +
                                      " г.р" +
                                      ")"
                                  ) +
                                  "\n                    "
                              ),
                              _c("br"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.status == 1 &&
                        e.param_request.serial_passport != null &&
                        e.param_request.number_passport != null
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  "Паспорт: " +
                                    e.param_request.serial_passport +
                                    " " +
                                    e.param_request.number_passport
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.param_request.inn_fl && e.status == 1
                          ? _c("span", [
                              _vm._v("ИНН: " + _vm._s(e.param_request.inn_fl)),
                            ])
                          : e.status == 0 || e.status == 2 || e.status == 3
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(e.param_request.surname) +
                                  " " +
                                  _vm._s(e.param_request.name) +
                                  " " +
                                  _vm._s(e.param_request.patronymic) +
                                  "\n                    "
                              ),
                              e.param_request.birthday
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          "(" +
                                            e.param_request.birthday +
                                            " г.р" +
                                            ")"
                                        ) +
                                        "\n                    "
                                    ),
                                    _c("br"),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              e.param_request.serial_passport &&
                              e.param_request.number_passport
                                ? _c("span", [
                                    _vm._v(
                                      "Паспорт: " +
                                        _vm._s(
                                          e.param_request.serial_passport +
                                            " " +
                                            e.param_request.number_passport
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              e.param_request.inn_fl
                                ? _c("span", [
                                    _vm._v(
                                      "ИНН: " + _vm._s(e.param_request.inn_fl)
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : e.status == 4 || e.status == -1
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.updateStatus(e)
                                  },
                                },
                              },
                              [
                                _c("a", { staticClass: "repeat-request" }, [
                                  _vm._v("Повторить проверку"),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.param_request.surname) +
                                    " " +
                                    _vm._s(e.param_request.name) +
                                    " " +
                                    _vm._s(e.param_request.patronymic) +
                                    "\n                    "
                                ),
                                e.param_request.birthday
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            "(" +
                                              e.param_request.birthday +
                                              " г.р" +
                                              ")"
                                          ) +
                                          "\n                    "
                                      ),
                                      _c("br"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.param_request.serial_passport &&
                                e.param_request.number_passport
                                  ? _c("span", [
                                      _vm._v(
                                        "Паспорт: " +
                                          _vm._s(
                                            e.param_request.serial_passport +
                                              " " +
                                              e.param_request.number_passport
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                e.param_request.inn_fl
                                  ? _c("span", [
                                      _vm._v(
                                        "ИНН: " + _vm._s(e.param_request.inn_fl)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.history.pagination && _vm.history.list.length
              ? _c("pagination", {
                  attrs: {
                    pagination: _vm.history.pagination,
                    onTurnPageCallBack: _vm.getList,
                    showRowsPerPageSelection: false,
                    rows_on_page: _vm.history.list.length,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("h2", [_vm._v("Проверка физических лиц")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group__header" }, [
      _vm._v("Фамилия"),
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group__header" }, [
      _vm._v("Имя"),
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group__header" }, [
      _vm._v("Дата рождения"),
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group__header" }, [
      _vm._v("Серия и номер паспорта"),
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
      _vm._v(" - поля обязательные к заполнению"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          margin: "60px 0 20px",
          color: "rgb(30, 139, 195)",
          "font-weight": "500",
          "font-size": "32px",
        },
      },
      [_c("span", [_vm._v("История проверок")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }